export default __webpack_public_path__ + "e4a5a7649f3fc8ea8acf9aa9fc6d02d4.svg";